import EcoImg from 'eco-design/base/eco-img';
import css from './index.module.scss';
import { useLang } from '@/i18n';
import EcoSpace from 'eco-design/base/eco-space';
import { useEffect, useRef } from 'react';
import { useWebpOrJpg } from '../../hooks/useWebpOrJpg';
import { useRouter } from 'next/router';

const L: React.FC = () => {
    const { t } = useLang('ats.L');
    const webpOrJpg = useWebpOrJpg('#smart-gateway-L');
    const { locale = '' } = useRouter();
    const sectionRef = useRef<HTMLDivElement>(null);
    useEffect(() => {
        if (!sectionRef.current) return;
        const title = sectionRef.current?.querySelector('.title');
        const desc = sectionRef.current?.querySelector('.desc');
        const img = sectionRef.current.querySelector('.img');
        const ani1 = AniContainer.create({
            triggerElement: sectionRef.current,
            triggerHook: 1,
            offset: '20%',
            duration: '100%',
            onEnter: () => {
                title?.classList.add('enter');
                desc?.classList.add('enter');
                img?.classList.add('enter');
            },
            onProcess: (process: number) => {
                if (process <= 0) {
                    title?.classList.remove('enter');
                    desc?.classList.remove('enter');
                    img?.classList.remove('enter');
                }
            },
        });
        return () => {
            ani1.destroy?.();
        };
    }, []);
    return (
        <>
            <EcoSpace />
            <section
                className={`${css.section} smart-gateway-L GtmModuleData-section`}
                id="smart-gateway-L"
                data-section-id={'smart-gateway-L'}
                data-section-title={t('title')}
                ref={sectionRef}
            >
                <div className="info">
                    <p className="title ani-1">{t('title')}</p>
                    <p className="desc ani-2">{t.rich('desc', { h: (a: string) => <span className="white">{a}</span> })}</p>
                </div>
                <div className="img ani-3">
                    <EcoImg
                        pc={webpOrJpg(
                            'https://websiteoss.ecoflow.com/upload/image/1761121433360/ats%20pc.jpg',
                            'https://websiteoss.ecoflow.com/upload/image/1761121446021/ats.webp',
                        )}
                        h5={webpOrJpg(
                            'https://websiteoss.ecoflow.com/upload/image/1761121433659/m_ats.jpg',
                            'https://websiteoss.ecoflow.com/upload/image/1761121446729/m_ats.webp',
                        )}
                    />
                </div>
            </section>
            {locale === 'us' && <EcoSpace />}
        </>
    );
};

export default L;
